/* eslint import/prefer-default-export: 0 */

import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'

import {
  LIST_UNIT_ALERTS_REQUEST, LIST_UNIT_ALERTS_RESPONSE, LIST_UNIT_ALERTS_RESPONSE_ERROR,
  LIST_COMMUNITY_ALERTS_REQUEST, LIST_COMMUNITY_ALERTS_RESPONSE, LIST_COMMUNITY_ALERTS_RESPONSE_ERROR,
} from '../constants'

function getLoaderId(action) {
  if (action.unitId) {
    return action.unitId
  }
  if (action.communityId) {
    return action.communityId
  }
  return ''
}

export function listAlertsByUnit(id) {
  const unitId = parseInt(id, 10)
  return (dispatch, getState) => {
    if (isCachedItem(getState().alertsByUnit, unitId)) {
      return
    }

    dispatch({
      type: LIST_UNIT_ALERTS_REQUEST,
      unitId,
      getLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/units/${unitId}/alerts`).then((response) => {
      dispatch({
        type: LIST_UNIT_ALERTS_RESPONSE,
        unitId,
        getLoaderId,
        alerts: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: LIST_UNIT_ALERTS_RESPONSE_ERROR,
        error,
        unitId,
        getLoaderId,
        alerts: [],
      })
    })
  }
}

export function listAlertsByCommunity(id) {
  const communityId = parseInt(id, 10)
  return (dispatch, getState) => {
    if (isCachedItem(getState().alertsByCommunity, communityId)) {
      return
    }

    dispatch({
      type: LIST_COMMUNITY_ALERTS_REQUEST,
      communityId,
      getLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/communities/${communityId}/alerts`).then((response) => {
      dispatch({
        type: LIST_COMMUNITY_ALERTS_RESPONSE,
        communityId,
        getLoaderId,
        alerts: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: LIST_COMMUNITY_ALERTS_RESPONSE_ERROR,
        communityId,
        getLoaderId,
        alerts: [],
      })
    })
  }
}
